// Detects empty HTML returned from the Markdown parser in api-consent:
// api-consent always returns at least: <div> </div>
// eslint-disable-next-line sonarjs/slow-regex
export const hasContent = (content: string | undefined) => !!(content && /^<.*?>.*?\S.*?<\/.*?>$/.test(content));
